var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCartBag = function SvgCartBag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 1.5c1.042 0 2.041.395 2.778 1.098a3.665 3.665 0 0 1 1.15 2.652V6H7.072v-.75c0-.995.414-1.948 1.151-2.652A4.026 4.026 0 0 1 11 1.5ZM16.5 6v-.75c0-1.392-.58-2.728-1.61-3.712A5.636 5.636 0 0 0 11 0a5.636 5.636 0 0 0-3.89 1.538A5.132 5.132 0 0 0 5.5 5.25V6H0v15c0 .796.331 1.559.92 2.121A3.22 3.22 0 0 0 3.144 24h15.714a3.22 3.22 0 0 0 2.223-.879c.589-.562.92-1.325.92-2.121V6h-5.5ZM1.571 7.5H20.43V21c0 .398-.166.78-.46 1.06a1.61 1.61 0 0 1-1.112.44H3.143a1.61 1.61 0 0 1-1.111-.44 1.466 1.466 0 0 1-.46-1.06V7.5Z",
    fill: "#F0EAE3"
  })));
};

export default SvgCartBag;